import { WelcomeKitData } from "@platform/types/dashboard.types";

export const welcomeKitData: WelcomeKitData = {
  files: [
    {
      name: "All Images",
      type: "ZIP",
      size: "200 KB",
      downloadUrl:
        "https://static.pollinator.coop/images/outreach/platform/participant/2026/pollinator-participant-social-media-kit.zip",
    },
  ],
  images: [
    {
      imageUrl:
        "https://static.pollinator.coop/images/outreach/platform/participant/2026/post/Pollinator_Participant_Portrait_Light.jpg",
      alt: "Pollinator Participant Post - Light Theme",
      downloadUrl:
        "https://static.pollinator.coop/images/outreach/platform/participant/2026/post/Pollinator_Participant_Portrait_Light.jpg",
    },
    {
      imageUrl:
        "https://static.pollinator.coop/images/outreach/platform/participant/2026/post/Pollinator_Participant_Portrait_Dark.jpg",
      alt: "Pollinator Participant Post - Dark Theme",
      downloadUrl:
        "https://static.pollinator.coop/images/outreach/platform/participant/2026/post/Pollinator_Participant_Portrait_Dark.jpg",
    },
    {
      imageUrl:
        "https://static.pollinator.coop/images/outreach/platform/participant/2026/story/Pollinator_Participant_Story_Light.jpg",
      alt: "Pollinator Participant Story - Light Theme",
      downloadUrl:
        "https://static.pollinator.coop/images/outreach/platform/participant/2026/story/Pollinator_Participant_Story_Light.jpg",
    },
    {
      imageUrl:
        "https://static.pollinator.coop/images/outreach/platform/participant/2026/story/Pollinator_Participant_Story_Dark.jpg",
      alt: "Pollinator Participant Story - Dark Theme",
      downloadUrl:
        "https://static.pollinator.coop/images/outreach/platform/participant/2026/story/Pollinator_Participant_Story_Dark.jpg",
    },
  ],
  captions: [
    {
      text: "I’m excited to announce my participation in @pollinator_coop this May! 🐝Pollinator is collaborative infrastructure for mutual support, and their five-week program matches practitioners in small cohorts of aligned peers. Pollinator is currently open to alumni, staff, and leaders from select orgs—but I have a few invites to share. Interested? 🐝Head to Pollinator.coop to learn more ✨",
    },
  ],
  links: [
    {
      title: "WK About the enrollment phase",
      icon: "FileText",
      url: "/support/enrollment-phase",
    },
    {
      title: "Invitations from organizations",
      icon: "Users",
      url: "/support/organization-invitations",
    },
    {
      title: "Why invite a friend to Pollinator?",
      icon: "HelpCircle",
      url: "/support/invite-friends",
    },
    {
      title: "See all Pollinator support articles",
      icon: "Newspaper",
      url: "/support/articles",
    },
  ],
};

